import { useTheme } from '@mui/material/styles';
import { Bar, ComposedChart, LabelList, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { chartColorsFor, chartMutedTextColor } from './chartColors';

export const DocAndHoursChart = ({ docAndHours }: { docAndHours: any[] }) => {
  const { palette } = useTheme();
  const isDark = palette.mode === 'dark';

  /* Duas series: as duas primeiras cores da sequencia do dashboard. */
  const [documentsColor, hoursColor] = chartColorsFor(isDark);
  const mutedText = chartMutedTextColor(isDark);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: '1 1 auto', width: '100%' }}>
      <p style={{ color: palette.text.primary, fontSize: 20, fontWeight: 700, margin: '0 0 4px 0', padding: '1px' }}>
        Quantidade de documentos e soma de horas por dia
      </p>
      <span style={{ color: mutedText, fontSize: 13, fontWeight: 400 }}>
        Número de horas por documento dos colaboradores afastados
      </span>
      <div style={{ position: 'relative', flex: '1 1 auto', minHeight: 250, marginTop: 16 }}>
        <div style={{ position: 'absolute', inset: 0 }}>
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart data={docAndHours}>
              <XAxis dataKey="name" tick={{ fontSize: 12, fill: mutedText }} />
              <YAxis yAxisId="1" tick={{ fontSize: 12, fill: mutedText }} />
              <YAxis orientation="right" yAxisId="2" tick={{ fontSize: 12, fill: mutedText }} />
              <Tooltip />
              <Legend />
              <Legend verticalAlign="top" />
              <Bar
                dataKey="Documentos"
                name="Quantidade de documentos enviados"
                barSize={20}
                fill={documentsColor}
                yAxisId="2"
              />
              <Line
                type="monotone"
                dataKey="Horas"
                name="Soma total de horas dos documentos no dia"
                stroke={hoursColor}
                yAxisId="1"
              >
                <LabelList dataKey="Horas" position="top" style={{ fontSize: 12, fill: mutedText }} />
              </Line>
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};
